export const environment = {
  production: true,
  apiAddress: 'https://api.bayadic.com',
  paypal: {
    paypalApiUrl: "https://api-m.paypal.com",
    clientID : "AToil9eskSiOzf_Dm6xYEmwx1vtU5PdTDQqbCyV1EZTzVj8VtLTn-JbwwLa76mhSZbZ1QVCz2UxpmFPF",
    planID: "P-590871817T6660310NBAVEEQ"
  },
};
// AToil9eskSiOzf_Dm6xYEmwx1vtU5PdTDQqbCyV1EZTzVj8VtLTn-JbwwLa76mhSZbZ1QVCz2UxpmFPF
// undefined
